import "./heading.css";
import { Fragment } from "react";

const Heading = ({ word, headingSize }) => {
  const letters = word.split("");
  const TagName = headingSize;

  return (
    <TagName>
      {letters.map((letter, index) => {
        return letter === " " ? (
          " "
        ) : letter === "," ? (
          <Fragment key={index}>
            <span
              className="letter"
              onMouseEnter={(e) => e.target.classList.add("animated-letter")}
              onMouseLeave={(e) =>
                setTimeout(
                  () => e.target.classList.remove("animated-letter"),
                  1000
                )
              }
            >
              {letter}
            </span>
            <br />
          </Fragment>
        ) : (
          <span
            className="letter"
            key={index}
            onMouseEnter={(e) => e.target.classList.add("animated-letter")}
            onMouseLeave={(e) =>
              setTimeout(
                () => e.target.classList.remove("animated-letter"),
                1000
              )
            }
          >
            {letter}
          </span>
        );
      })}
    </TagName>
  );
};

export default Heading;
